export type PeriodKey =
  | "7_days"
  | "90_days"
  | "6_months"
  | "2_years"
  | "always"
  | "custom";

export interface PeriodOption {
  title: string;
  value: PeriodKey;
}

export const PERIOD_OPTIONS: Record<PeriodKey, PeriodOption> = {
  "7_days": { title: "7 dias", value: "7_days" },
  "90_days": { title: "90 dias", value: "90_days" },
  "6_months": { title: "6 meses", value: "6_months" },
  "2_years": { title: "2 anos", value: "2_years" },
  always: { title: "Sempre", value: "always" },
  custom: { title: "Intervalo personalizado", value: "custom" },
};
